import moment from 'moment'
import { DATE } from '@/constants/constants'
import { uiHelper } from '@/utils'

export default function dateFormat(value, format) {
  let lang = uiHelper.getLocalStorage('language')
  moment.locale(lang === 'zh' ? 'zh-cn' : lang)
  let result = ''

  if (value !== undefined && value !== null && value !== '') {
    return format ? moment(value, format).format(DATE.SHORT) : moment(String(value)).format(DATE.SHORT)
  }

  return result
}
